import { Row, Col } from 'reactstrap';
import CardButton from '../../../components/CardButton';
import Modal from '../../../components/modal/Modal';
import { useDict } from '../../../contexts/LanguageContext';

const InvestOptionModal = (props) => {
    const { handleClose, isOpen, openInvestModal } =
        props;

    const dict = useDict();

    return (
        <Modal
            toggle={handleClose}
            isOpen={isOpen}
            testID="investOptionModal"
            cancelText={dict.cancel}
            onCancel={handleClose}
            headerType="review-2"
            title={dict.invest}
        >
            <Row className="justify-content-start">
                <Col xs={12}>
                    <p className="font-weight-bold mb-2 text-left">
                        {dict.manualInvest}
                    </p>
                    <CardButton
                        buttonTitle={dict.bankTransfer}
                        onClick={openInvestModal}
                        type="lightBlue"
                        testID="bankTransfer"
                    />
                </Col>
            </Row>
        </Modal>
    );
};

export default InvestOptionModal;
